<template>
  <div id="page-supliers-list">
    <div class="vx-card p-6">
      <vs-table
        id="table-loading"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="this.length"
        search
        :data="users"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div
              v-if="checkPermissionByIds([permissions.USER_ADD])"
              @click="$router.push('/users/create')"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New User</span>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="user.id">Sr#</vs-th>
          <vs-th sort-key="user.username">User Name</vs-th>
          <vs-th sort-key="user.mobile">Mobile</vs-th>
          <vs-th sort-key="user.email">Email</vs-th>
          <vs-th sort-key="role.role_name">Role</vs-th>
          <vs-th>Migrate Metrc</vs-th>
          <vs-th>Download Invalid Item</vs-th>
          <vs-th sort-key="user.created_at">Created On</vs-th>
          <vs-th v-if="checkPermissionByIds([permissions.USER_EDIT])">Status</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.username }}
            </vs-td>
            <vs-td>
              {{ tr.mobile }}
            </vs-td>
            <vs-td>
              {{ tr.email }}
            </vs-td>
            <vs-td>
              {{ tr.role.role_name }}
            </vs-td>
            <vs-td>
              <vs-switch color="primary" :disabled="tr.migrate_metrc == true" :value="tr.migrate_metrc" @click="updateMigrateMetrcStatus(tr, !tr.migrate_metrc)">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td>
              <feather-icon icon="DownloadIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="downloadExcel(tr)" />
            </vs-td>
            <vs-td>
              {{ formatDateTime(tr.created_at) }}
            </vs-td>
            <vs-td v-if="checkPermissionByIds([permissions.USER_EDIT])">
              <vs-switch color="primary" :value="tr.status" @input="updateStatus(tr.id, !tr.status)">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </vs-td>
            <vs-td :data="tr.id">
              <div class="inline-flex" v-if="checkPermissionByIds([permissions.USER_EDIT, permissions.USER_DELETE])" :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                <vx-tooltip v-if="checkPermissionByIds([permissions.USER_EDIT])" text="Edit User">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="sendToEditPage(tr.id)" />
                </vx-tooltip>
                <vx-tooltip v-if="checkPermissionByIds([permissions.USER_DELETE])" text="Delete User">
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4  hover:text-danger cursor-pointer" @click="deleteRecord(tr.id)" />
                </vx-tooltip>
                <vx-tooltip v-if="user.roleId === roles.ADMIN && tr.roleId == roles.MULTILOCATION" text="Assign Users">
                  <feather-icon icon="ListIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="$router.push(`/users/${tr.id}/assign-users`)" />
                </vx-tooltip>
              </div>
              <div v-else>-</div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- pagination -->
      <vs-pagination v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : totalPages" class="mt-8"></vs-pagination>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapGetters, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'UserList',
  data: () => ({
    selected: [],
    order: [],
    length: 10,
    page: 1,
    search: '',
    invalidData: []
  }),

  mixins: [dateMixins],

  methods: {
    sendToEditPage(id) {
      this.$router.push(`/users/${id}/edit`)
    },

    downloadExcel(tr) {
      this.downloadInvalidData(tr)
    },

    exportExcel(data) {
      // const invalidItems = data.invalidItems
      console.log(data, 'data exported')
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(
        data.map((item) => ({
          name: item.product_name || item.inventory_name,
          'category name': item.category && item.category.category_name,
          'strain name': 'Beginning Inventory Strain',
          'weight type': item.weight_type,
          'sales price': item.sales_price || item.price,
          quantity: item.quantity,
          userId: item.userId,
          groupId: item.groupId
        }))
      )
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      XLSX.writeFile(wb, 'Invalid Items.csv')
    },

    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this user?',
        accept: () => this.deleteUser(id),
        acceptText: 'Delete'
      })
    },

    updateStatus(id, status) {
      this.$store
        .dispatch('user/updateStatus', {
          id,
          status
        })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'User status updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    updateMigrateMetrcStatus(user) {
      this.processing = true
      this.$store
        .dispatch('user/updateMigrateMetrcStatus', user)
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.status = null
          this.processing = false
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.processing = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    downloadInvalidData(user) {
      this.processing = true
      this.$store
        .dispatch('user/downloadInvalidData', user)
        .then((response) => {
          console.log(response, 'response from invalid data')
          this.$vs.notify({
            title: 'Success',
            text: response.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.processing = false
          this.exportExcel(response.data)
        })
        .catch((err) => {
          const { message } = err
          this.processing = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    deleteUser(id) {
      this.$store
        .dispatch('user/delete', id)
        .then(() => {
          if (this.users.length === 1 && this.page !== 1) {
            this.page -= 1
          }
          this.$vs.notify({
            title: 'Success',
            text: 'User deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      const { page, length, order, search } = this
      this.$store
        .dispatch('user/getUsers', {
          page,
          limit: length,
          order,
          search
        })
        .then(() => {})
        .catch(() => {})
    }
  },
  computed: {
    ...mapState('user', ['users', 'total', 'loading', 'FilteredCount']),
    ...mapState('permission', ['permissions', 'roles']),
    ...mapGetters('auth', ['checkPermissionByIds']),
    ...mapState('auth', ['user']),

    // set total pages for pagination
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#table-loading',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#table-loading > .con-vs-loading')
      }
    },

    page() {
      this.handleChangePage(this.page)
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
